import type { TVConfig } from '@nuxt/ui';
import type * as ui from '#build/ui';

export default {
    slots: {
        root: 'mb-8',
    }
} satisfies TVConfig<typeof ui>['pageHeader'];
